import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';

import DownloadCta from './DownloadCta';
import ForSubscribers from './ForSubscribers';
import Hero from './Hero';
import HowItWorks from './HowItWorks';
import WhyPolls from './WhyPolls';
import { DevicePlatform } from './constants';

interface PollsAppProps {
  platform: DevicePlatform;
  qrUrl: string;
  isCurrentUserSubscriber?: boolean;
}

const PollsApp = ({ platform, qrUrl, isCurrentUserSubscriber = false }: PollsAppProps) => {
  const { Track } = useEventTracking({
    page: Page.PollsApp,
  });
  return (
    <Track>
      <main>
        <Hero platform={platform} qrUrl={qrUrl} />
        <HowItWorks />
        <WhyPolls />
        {!isCurrentUserSubscriber && <ForSubscribers />}
        <DownloadCta platform={platform} qrUrl={qrUrl} />
      </main>
    </Track>
  );
};

export default PollsApp;
